var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors && _vm.errors.length >0)?_c('div',{staticClass:"has-error error--text"},[_vm._t("default"),_vm._l((_vm.errors),function(error,index){return _c('p',{key:index,staticClass:"error-message"},[_vm._v(" "+_vm._s(error)+" ")])})],2):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }